if (!customElements.get('sale-countdown')) {
  class SaleCountdown extends HTMLElement {
    connectedCallback() {
      this.endTime = this.parseEndTime(this.dataset.end, this.dataset.timezone);
      this.threshold = parseInt(this.dataset.threshold, 10) * 3600000;
      this.hoursEl = this.querySelector('[data-hours]');
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');
      this.slideEl = this.closest('.slideshow__slide, .announcement-bar');
      this.sliderEl = this.closest('slideshow-component');
      this.slideRemoved = false;

      this.tick();
      this.interval = setInterval(this.tick.bind(this), 1000);
    }

    parseEndTime(dateStr, timezone) {
      if (!dateStr) return 0;
      var parts = dateStr.match(/(\d{4})-(\d{1,2})-(\d{1,2})T(\d{1,2}):(\d{1,2})/);
      if (!parts) return new Date(dateStr).getTime();

      var year = parseInt(parts[1], 10);
      var month = parseInt(parts[2], 10);
      var day = parseInt(parts[3], 10);
      var hour = parseInt(parts[4], 10);
      var minute = parseInt(parts[5], 10);

      if (!timezone) {
        return new Date(year, month - 1, day, hour, minute, 0).getTime();
      }

      /* Find the UTC ms where wall-clock in `timezone` equals the entered values.
         Use formatToParts to reliably read wall-clock components, then refine. */
      var fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: timezone,
        year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', second: 'numeric',
        hour12: false
      });

      function wallParts(ms) {
        var p = fmt.formatToParts(new Date(ms));
        var o = {};
        for (var i = 0; i < p.length; i++) {
          if (p[i].type !== 'literal') o[p[i].type] = parseInt(p[i].value, 10);
        }
        return o;
      }

      // Iteratively find the UTC ms whose wall-clock in `timezone` equals
      // the target. The loop refines `guess` by the ERROR between target
      // and observed wall-clock. Earlier code used (guess - wallUtc)
      // which equals the timezone offset and got applied EVERY pass —
      // pass 1 corrected to the right value, pass 2 over-corrected by
      // another offset (e.g. setting 11:59 Pacific saved 18:59 Pacific).
      // Two passes is enough to absorb DST transitions that fall
      // between the initial guess and the corrected time.
      var targetWallUtc = Date.UTC(year, month - 1, day, hour, minute, 0);
      var guess = targetWallUtc;
      for (var pass = 0; pass < 2; pass++) {
        var w = wallParts(guess);
        var observedWallUtc = Date.UTC(w.year, w.month - 1, w.day, w.hour === 24 ? 0 : w.hour, w.minute, 0);
        var error = targetWallUtc - observedWallUtc;
        if (error === 0) break;
        guess += error;
      }
      return guess;
    }

    updateArrows() {
      if (!this.sliderEl) return;
      var slides = this.sliderEl.querySelectorAll('.slideshow__slide');
      var arrows = this.sliderEl.querySelectorAll('.slider-button');
      var hide = slides.length <= 1;
      arrows.forEach(function(btn) { btn.style.display = hide ? 'none' : ''; });
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    tick() {
      var now = Date.now();
      var remaining = this.endTime - now;

      if (remaining <= 0 || remaining > this.threshold) {
        if (this.slideEl && !this.slideRemoved) {
          this.slideParent = this.slideEl.parentNode;
          this.slideNextSibling = this.slideEl.nextSibling;
          this.slideEl.remove();
          this.slideRemoved = true;
          this.updateArrows();
        }
        if (remaining <= 0 && this.interval) {
          clearInterval(this.interval);
          this.interval = null;
        }
        return;
      }

      if (this.slideRemoved && this.slideParent) {
        this.slideParent.insertBefore(this.slideEl, this.slideNextSibling);
        this.slideRemoved = false;
        this.updateArrows();
      }
      this.style.display = 'flex';

      var hours = Math.floor(remaining / 3600000);
      var minutes = Math.floor((remaining % 3600000) / 60000);
      var seconds = Math.floor((remaining % 60000) / 1000);

      this.hoursEl.textContent = String(hours).padStart(2, '0');
      this.minutesEl.textContent = String(minutes).padStart(2, '0');
      this.secondsEl.textContent = String(seconds).padStart(2, '0');
    }
  }

  customElements.define('sale-countdown', SaleCountdown);
}
